export default "__VITE_ASSET__D2j2gHzc__"